import React from "react"

export const SearchStatsWrapper = ({ children }) => {
  return <div className="text-sm italic stats text-ultraLight">{children}</div>
}
